import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrows = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 91,
	height: 36,
	viewBox: "0 0 91 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M73.3355 30.6445L86.2097 18.3834C86.5718 18.0386 86.5718 17.461 86.2097 17.1162L73.3355 4.85505",
			stroke: "#357DED",
			strokeWidth: 8.75,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.2771 30.6445L67.5532 18.3685C67.8949 18.0268 67.8949 17.4728 67.5532 17.1311L55.2771 4.85505",
			stroke: "#357DED",
			strokeOpacity: .8,
			strokeWidth: 7,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.2303 30.6445L49.5063 18.3685C49.848 18.0268 49.848 17.4728 49.5063 17.1311L37.2303 4.85505",
			stroke: "#357DED",
			strokeOpacity: .6,
			strokeWidth: 5.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1834 30.6445L31.4594 18.3685C31.8011 18.0268 31.8011 17.4728 31.4594 17.1311L19.1834 4.85505",
			stroke: "#357DED",
			strokeOpacity: .4,
			strokeWidth: 3.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.12089 30.6445L13.3969 18.3685C13.7386 18.0268 13.7386 17.4728 13.3969 17.1311L1.12089 4.85505",
			stroke: "#357DED",
			strokeOpacity: .2,
			strokeWidth: 1.75,
			strokeLinecap: "round"
		})
	]
});
export default SvgArrows;
